import { deleteCookie } from 'cookies-next/client'
import { authCookieName } from './setAuthCookie'

interface Props {
  options?: {
    path?: string
    domain?: string
  }
}

export const removeAuthCookie = ({ options = { path: '/' } }: Props) => {
  if (typeof window === 'undefined') {
    throw new TypeError(
      'Cookies.js::This method can only be called in the Client/browser',
    )
  }

  const cookieOptions = {
    ...options,
    maxAge: -1, // Immediately expire the cookie
  }

  // Remove the cookie for the default domain
  deleteCookie(authCookieName, cookieOptions)
  // Remove the cookie for specific domains
  deleteCookie(authCookieName, {
    ...cookieOptions,
    domain: '.unicity.com',
  })

  deleteCookie(authCookieName, {
    ...cookieOptions,
    domain: 'shop2.unicity.com',
  })

  deleteCookie(authCookieName, {
    ...cookieOptions,
    domain: window.location.hostname,
  })
}
